/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppTemplateArchive } from '../../axios/whatsAppTemplateArchive'
import type {
	WhatsAppTemplateArchiveError,
	WhatsAppTemplateArchivePathParams,
	WhatsAppTemplateArchiveResponse,
} from '../../types/WhatsAppTemplateArchive'

export const whatsAppTemplateArchiveMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-templates/:templateId/archive' }] as const

export type WhatsAppTemplateArchiveMutationKey = ReturnType<typeof whatsAppTemplateArchiveMutationKey>

export type WhatsAppTemplateArchiveVariables = {
	organisationId: WhatsAppTemplateArchivePathParams['organisationId']
	templateId: WhatsAppTemplateArchivePathParams['templateId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::archive */
export function useWhatsAppTemplateArchive<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppTemplateArchiveResponse,
		AxiosError<WhatsAppTemplateArchiveError>,
		WhatsAppTemplateArchiveVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppTemplateArchiveMutationKey(),
		mutationFn: ({ organisationId, templateId }: WhatsAppTemplateArchiveVariables) =>
			whatsAppTemplateArchive(organisationId, templateId, config).then(res => res.data),
		...options,
	})
}
